<script setup>
import { watch } from 'vue';
import { useQuasar } from 'quasar';
import fontList from '@/components/admin/fontList.js';
import { UserService } from '../../../services';
import { useBingoStore } from '@/stores/bingo/bingo.store';

const props = defineProps({
  clientId: {
    type: String,
    required: true,
  },
});

const quasar = useQuasar();
const bingoStore = useBingoStore();

watch(
  () => bingoStore.clientData.common,
  async () => {},
);

async function sendGKSData() {
  if (props.clientId) {
    const res = await UserService.sendBingoCommonData(
      props.clientId,
      bingoStore.clientData.common,
    );
    if (res) {
      quasar.notify({
        type: 'info',
        message: `Wysłano dane klienta`,
      });
    } else {
      quasar.notify({
        type: 'negative',
        message: `Błąd w przesyle danych`,
      });
    }
  } else {
    quasar.notify({
      type: 'negative',
      message: `Nie wybrano wszystkich pól`,
    });
  }
}
</script>

<template>
  <q-form ref="ClientForm" class="form" @submit.prevent="sendGKSData">
    <div class="send">
      <button class="core-default-form-button" type="submit">Wyślij</button>
    </div>
    <!-- <InputSelect
      v-model="bingoStore.clientData.common.version"
      class="input"
      :select-options="versionList"
      main-color="#84491f"
      background-color="#fffbf8"
      text-font="Raleway"
      >Wersja</InputSelect
    > -->
    <div class="inputs">
      <div class="input">
        <p class="label">Czcionka</p>
        <q-select
          v-model="bingoStore.clientData.common.textFont"
          borderless
          class="core-default-input-form core-default-input-form"
          :options="fontList"
        />
      </div>
      <div class="input">
        <p class="label">Główny kolor</p>
        <q-input
          v-model="bingoStore.clientData.common.mainColor"
          class="core-default-input-form"
          borderless
          autogrow
          lazy-rules
          :rules="[(val) => !!val || 'To pole nie może być puste', 'anyColor']"
        >
          <template #append>
            <q-icon name="colorize" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-color v-model="bingoStore.clientData.common.mainColor" />
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="input">
        <p class="label">Kolor tła</p>
        <q-input
          v-model="bingoStore.clientData.common.backgroundColor"
          class="core-default-input-form"
          borderless
          autogrow
          lazy-rules
          :rules="[(val) => !!val || 'To pole nie może być puste', 'anyColor']"
        >
          <template #append>
            <q-icon name="colorize" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-color
                  v-model="bingoStore.clientData.common.backgroundColor"
                />
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="input">
        <p class="label">Czy wymagane są pliki</p>
        <Checkbox
          v-model="bingoStore.clientData.common.isFileRequired"
          binary
        />
      </div>
      <div class="input">
        <p class="label">Czy jest tablica wyników</p>
        <Checkbox v-model="bingoStore.clientData.common.isScoreboard" binary />
      </div>
    </div>
  </q-form>
</template>

<style lang="scss" scoped>
@import '@/components/admin/form';
</style>
